import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/list-duck";
import { TransportFile } from "interfaces/transport-file";

const { Types, Creators } = createActions(
  {
    request: ["query", "onSuccess"],
    success: ["data"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "LIST_TRANSPORT_FILES" }
);

export interface ListTransportFilesState extends IState {
  data: TransportFile[];
}

interface ISuccessListTransportFilesAction extends ISuccessAction {
  data: TransportFile[];
}

const INITIAL_STATE: ListTransportFilesState = {
  data: [],
  loading: false,
  error: null,
};

const request = (state: ListTransportFilesState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (
  state: ListTransportFilesState, 
  action: ISuccessListTransportFilesAction,
) =>
  update(state, {
    data: { $set: action.data },
    loading: { $set: false },
  });

const failure = (state: ListTransportFilesState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const listTransportFiles = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const ListTransportFilesTypes = Types;
export const ListTransportFilesActions = Creators;
